import { Injectable } from '@angular/core';
import { OccProductsResponse } from '@catalog/const';
import { CatalogActions, OccCatalogProductService } from '@catalog/data-access';
import { CityActions } from '@city/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomProductActions } from '@product/data-access';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilKeyChanged, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class ProductEffects {
  loadProductsByCodes$: Observable<CatalogActions.LoadProductsByCodesSuccess | CatalogActions.LoadProductsByCodesFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(CatalogActions.LOAD_PRODUCTS_BY_CODES),
        mergeMap((action: CatalogActions.LoadProductsByCodes) => {
          const { productCodes, scope } = action;

          return this.occCatalogProductService.loadProductsByCodes(productCodes).pipe(
            map((response: OccProductsResponse) => {
              return new CatalogActions.LoadProductsByCodesSuccess(productCodes, response.products, scope);
            }),
            catchError(() => {
              return of(new CatalogActions.LoadProductsByCodesFail(productCodes, scope));
            }),
          );
        }),
      ),
    );

  productDetailResetState$: Observable<CustomProductActions.ProductDetailResetState> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      distinctUntilKeyChanged('payload'),
      map(() => new CustomProductActions.ProductDetailResetState()),
    ),
  );

  constructor(
    private actions$: Actions,
    private occCatalogProductService: OccCatalogProductService,
  ) {}
}
